import {Button, Col, Container, FormControl, Row, Spinner} from "react-bootstrap";

import DataTable from 'react-data-table-component';
import {useEffect, useState} from "react";
import {getAllJobs} from "../service/JobService";
import JobExpand from "./JobExpand";
import JobStatusToggleGroup from "./JobStatusToggleGroup";
import {getFieldWorkers, getSuperVisor} from "../service/UserService";
import UpdateButtonMenu from "./UpdateJobButtonMenu";
import DateRangeSelector from "./DateRangeSelector";


const customStyles = {
    rows: {
        style: {
            minHeight: '32px', // override the row height
        },
    }
};


export default function ManageJob() {
    const now = new Date();
    const [isLoading, setIsLoading] = useState(false)
    const [tableData, setTableData] = useState([])

    const [fieldWorkerMap, setFieldWorkerMap] = useState({})
    const [filteredData, setFilteredData] = useState([])
    const [fieldSupervisorMap, setFieldSupervisorMap] = useState({})
    const [fieldSupervisorArray, setfieldSupervisorArray] = useState([])

    const [radioValue, setRadioValue] = useState(() => {
        const radioValue = localStorage.getItem('radioValue');
        return radioValue ? radioValue : "ALL";
    });
    const [statusCounts, setStatusCounts] = useState({})

    const [selectionRange, setSelectionRange] = useState(() => {
        const startDate = localStorage.getItem('startDate');
        const endDate = localStorage.getItem('endDate');
        const defaultRange = {
            startDate: new Date(new Date().setDate(now.getDate() - 14)),
            endDate: new Date(new Date().setDate(now.getDate() + 14)),
            key: 'selection',
        }
        if (startDate) {
            defaultRange.startDate = new Date(parseInt(startDate))
        }
        if (endDate) {
            defaultRange.endDate = new Date(parseInt(endDate))
        }
        return defaultRange;
    })

    const [searchText, setSearchText] = useState(() => {
        const searchText = localStorage.getItem('searchText');
        return searchText ? searchText : "";
    });

    const columns = [

        {
            name: 'ID', selector: row => row.cos_job_id, sortable: true, width: '80px',
        }, {
            name: 'Address', selector: row => row.full_address, sortable: true, maxWidth: '200px'
        }, {
            name: 'Key', selector: row => row.key_number, sortable: true, width: '85px',
        }, {
            name: 'Customer Name', selector: row => row.cos_customer_name, sortable: true, width: '100px',
        }, {
            name: 'Agent Name', selector: row => row.agent_name, sortable: true, width: '100px',
        }, {
            name: 'Worker',
            selector: row => fieldWorkerMap[row.cos_job_worker] ? fieldWorkerMap[row.cos_job_worker] : row.cos_job_worker,
            sortable: true,
            width: '100px',
        },
        {
            name: 'Supervisor',
            selector: row => fieldSupervisorMap[row.cos_job_supervisor] ? fieldSupervisorMap[row.cos_job_supervisor] : row.cos_job_supervisor,
            sortable: true,
            width: '100px',
        },

        {
            name: 'Date', selector: row => row.date, sortable: true, width: '110px',
        }, {
            name: 'Status',
            selector: row => row.has_admin_notes === true ? row.status + String.fromCharCode(9997) : row.status,
            sortable: true,
            width: '150px'
        }, {
            cell: row => <UpdateButtonMenu row={row}/>, allowoverflow: true, button: "true", width: '56px',
        }];

    function refreshJobList(currentSelectionRange) {
        setFilteredData([])
        setIsLoading(true)
        getAllJobs(currentSelectionRange.startDate, currentSelectionRange.endDate).then(response => {
            if (response.status === 200) {

                response.json().then(result => {
                    const counts = {};
                    for (const job of result) {
                        counts[job.status] = counts[job.status] ? counts[job.status] + 1 : 1;
                    }
                    setStatusCounts(counts)
                    filterTables(result, radioValue, searchText)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error))
            .finally(() => {
                setIsLoading(false)
            });
    }

    function refreshFieldWorkers() {
        getFieldWorkers().then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    let tmpFieldWorkerMap = {};
                    result.map(obj => {
                        tmpFieldWorkerMap[obj.id] = obj.name
                    })
                    setFieldWorkerMap(tmpFieldWorkerMap)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    function refreshSupervisors() {
        getSuperVisor().then(response => {
            if (response.status === 200) {
                response.json().then(result => {
                    setfieldSupervisorArray(result);
                    let tmpFieldSupervisorMap = {};
                    result.map(obj => {
                        tmpFieldSupervisorMap[obj.id] = obj.name
                    })
                    setFieldSupervisorMap(tmpFieldSupervisorMap)
                })
            } else {
                response.text().then(result => console.log(result))
            }
        }).catch(error => console.log('error', error));
    }

    useEffect(() => {
        refreshSupervisors();
        refreshFieldWorkers();
        refreshJobList(selectionRange);
    }, []);

    function handleSelect(ranges) {
        setSelectionRange(ranges.selection);
        localStorage.setItem('startDate', ranges.selection.startDate.getTime());
        localStorage.setItem('endDate', ranges.selection.endDate.getTime());
        refreshJobList(ranges.selection);
    }

    function filterTables(rawdata, radioValue, searchText) {
        let tempData = rawdata
        if (radioValue !== 'ALL') {
            tempData = rawdata.filter(item => item.status && item.status.includes(radioValue),);
        }
        //cos_customer_name, username, agent_name, phone, email
        if (searchText && searchText.length > 0) {
            tempData = tempData.filter(item => (item.full_address && item.full_address.toLowerCase().includes(searchText.toLowerCase())
                || (item.agent_name && item.agent_name.toLowerCase().includes(searchText.toLowerCase()))
                || (item.cos_customer_name && item.cos_customer_name.toLowerCase().includes(searchText.toLowerCase()))
                || (item.phone && item.phone.toLowerCase().includes(searchText.toLowerCase()))
                || (item.email && item.email.toLowerCase().includes(searchText.toLowerCase()))
                || (item.cos_job_id && item.cos_job_id.toLowerCase().includes(searchText.toLowerCase()))
                || (item.cos_job_supervisor && fieldSupervisorMap[item.cos_job_supervisor] && fieldSupervisorMap[item.cos_job_supervisor].toLowerCase().includes(searchText.toLowerCase()))
                || (item.cos_job_worker && fieldWorkerMap[item.cos_job_worker] && fieldWorkerMap[item.cos_job_worker].toLowerCase().includes(searchText.toLowerCase()))));
        }
        setTableData(rawdata)
        setFilteredData(tempData)
    }


    function toggleRoleFilter(value) {
        setRadioValue(value)
        localStorage.setItem('radioValue', value);
        filterTables(tableData, value, searchText)
    }

    function filterSearchText(value) {
        setSearchText(value)
        localStorage.setItem('searchText', value);
        filterTables(tableData, radioValue, value)

    }

    return (<Container fluid>
            <Row>
                <Col sm={12}>
                    <Container fluid>
                        <div className="d-flex flex-wrap align-items-center mb-2">
                            <div className="d-flex align-items-center flex-grow-1">
                                <JobStatusToggleGroup
                                    radioValue={radioValue}
                                    setRadioValue={toggleRoleFilter}
                                    statusCounts={statusCounts}/>
                            </div>
                            <div className="d-flex align-items-center justify-content-center flex-grow-1 mt-2 mt-md-0">
                                <DateRangeSelector
                                    startDate={selectionRange.startDate}
                                    endDate={selectionRange.endDate}
                                    onDateChange={handleSelect}
                                />
                            </div>
                            <div className="d-flex align-items-center flex-grow-1 justify-content-end mt-2 mt-md-0">
                                <Button variant="secondary" disabled={isLoading}
                                        onClick={() => refreshJobList(selectionRange)}
                                        style={{width: "90px", display: "flex", justifyContent: "center"}}>
                                    {isLoading ? <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    /> : "Refresh"}
                                </Button>
                                <FormControl
                                    value={searchText}
                                    onChange={(e) => filterSearchText(e.target.value)}
                                    type="search"
                                    placeholder="Search"
                                    className="ms-2"
                                    style={{width: "180px"}}
                                    aria-label="Search"
                                    disabled={isLoading}
                                />
                            </div>
                        </div>
                        <Row>
                            {filteredData.length > 0 ? <DataTable
                                columns={columns}
                                data={filteredData}
                                expandableRows
                                expandableRowsComponent={JobExpand}
                                customStyles={customStyles}
                                pagination
                                highlightOnHover
                                expandOnRowClicked
                            /> : <div style={{
                                height: "200px",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center"
                            }}>
                            <span>No Job available on Current Date and Filter <br/>
                            <a href="#" onClick={() => {
                                filterSearchText("")
                            }}>Try Clear Filter</a></span>
                            </div>}

                        </Row>
                    </Container>


                </Col>


            </Row>


        </Container>


    );
}
